import {
  OPEN_SUBSCRIPTION_POPUP,
  CLOSE_SUBSCRIPTION_POPUP,
} from "GlobalActionTypes/SubscriptionPopup";

const initialState = {
  isActive: false,
  modelId: -1,
  makeName: "",
  modelName: "",
};

export const subscriptionPopup = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_SUBSCRIPTION_POPUP:
      return {
        isActive: true,
        modelId: action.data.modelId,
        makeName: action.data.makeName,
        modelName: action.data.modelName,
      };
    case CLOSE_SUBSCRIPTION_POPUP:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
